<script setup>
/******************************************************************************
 * component: Header wrapper
 *****************************************************************************/
import AppHeaderTitle from "./AppHeaderTitle.vue";
import AppHeaderNavigation from "./AppHeaderNavigation.vue";
</script>

<template>
    <header>
        <app-header-title />
        <app-header-navigation />
    </header>
</template>

<style lang="scss" scoped>
header {
    position: sticky;
    top: 0;
    z-index: get($z, "header");

    width: 100%;
    max-width: get($breakpoints, "large");

    background-color: get($client, "headerBg");
}
</style>
